import { render } from "./UserListSwipe.vue?vue&type=template&id=4f5ce9d4&scoped=true"
import script from "./UserListSwipe.vue?vue&type=script&lang=js"
export * from "./UserListSwipe.vue?vue&type=script&lang=js"

import "./UserListSwipe.vue?vue&type=style&index=0&id=4f5ce9d4&scoped=true&lang=css"

import exportComponent from "/Users/gaomingliang/github/vue3_wzheros/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5ce9d4"]])

export default __exports__